import { Component } from '@angular/core'
import { Observable } from 'rxjs'
import { DashboardSidebarService } from '../../services/dashboard-sidebar.service'

@Component({
    selector: 'app-dashboard-layout',
    templateUrl: './dashboard-layout.component.html',
    styleUrls: ['./dashboard-layout.component.scss']
})
export class DashboardLayoutComponent {
    constructor(private dashboardSidebarService: DashboardSidebarService) {}

    closeSidebar(): void {
        this.dashboardSidebarService.hideSidebar()
    }

    toggleSidebar(): void {
        this.dashboardSidebarService.toggleSidebar()
    }

    get isMobile$(): Observable<boolean> {
        return this.dashboardSidebarService.isMobile$
    }

    get isOpenSidebar$(): Observable<boolean> {
        return this.dashboardSidebarService.isOpenSidebar$
    }
}
